import React from 'react';

const ScrollIndicator = ({ targetId, style = {} }) => {
  const handleClick = () => {
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div 
      className="section-scroll-indicator"
      onClick={handleClick}
      style={style}
      data-testid={`scroll-to-${targetId}`}
    >
      <span className="scroll-indicator-text">Scroll</span>
      <div className="scroll-indicator-arrow"></div>
    </div>
  );
};

export default ScrollIndicator;
